module.exports = __webpack_public_path__ + "media/images/ico-share-dc1e65d9.svg";